import { Avatar, BuildingIcon, Flex, Text } from "@fluentui/react-northstar";
import { BuildingBank20Filled } from "@fluentui/react-icons";
import React from "react";
import styled from "styled-components";

export default function UserCard({ user }) {
    return (
        <UserCards vAlign="center" gap="gap.medium">
            <Avatar image={user?.avatar} size="larger" name={user?.name} />
            <Flex
                styles={{
                    paddingBlock: "8px",
                }}
                gap="gap.smaller"
                column
            >
                <UserName content={user?.name} />
                <Flex gap="gap.small">
                    <DepartementFlex vAlign="center" gap="gap.small">
                        <BuildingBank20Filled />
                        <div
                            style={{
                                width: "2px",
                                background: "#D1D1D1",
                                height: "15px",
                            }}
                        />
                        <DepartementName content={user?.agency?.name} />
                    </DepartementFlex>
                    <DepartementFlex vAlign="center" gap="gap.small">
                        <BuildingIcon />
                        <div
                            style={{
                                width: "2px",
                                background: "#D1D1D1",
                                height: "15px",
                            }}
                        />
                        <DepartementName content={user?.department?.name} />
                    </DepartementFlex>
                </Flex>
            </Flex>
        </UserCards>
    );
}

const UserCards = styled(Flex)``;
const UserName = styled(Text)`
    color: #424242;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
`;
const DepartementFlex = styled(Flex)`
    border-radius: 4px;
    background: #ebebeb;
    padding: 4px 8px;
`;
const DepartementName = styled(Text)`
    color: var(#424242);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;
